import Vue from 'vue'
import VueRouter from 'vue-router'

const routes = [
    {
        path: '/result',
        name: 'result',
        component: () => import('../views/result.vue')
    },
    {
        path: '/:id',
        name: 'home',
        component: () => import('../views/index.vue')
    }

]

Vue.use(VueRouter)

const router = new VueRouter({
    mode:'history',
    routes
})


export default router